export default "__VITE_ASSET__d714185a__"